import React from "react";
import { useTranslation } from "react-i18next";

export function MailchimpNewsletterForm(props) {
    const { t } = useTranslation();

    const mailchimpNewsletterHTML =
        "<h2>" +
        t("newsletter-section-title") +
        "</h2>" +
        "<p>" +
        t("newsletter-section-text") +
        "</p>" +
        "<!-- Begin Mailchimp Signup Form -->" +
        '<link href="//cdn-images.mailchimp.com/embedcode/classic-071822.css" rel="stylesheet" type="text/css">' +
        '<div id="mc_embed_signup">' +
        '<form action="https://2xper.us14.list-manage.com/subscribe/post?u=fd9e30f054d2eb89045417926&amp;id=88d8999242&amp;v_id=5051&amp;f_id=0087b6e5f0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank">' +
        '<div id="mc_embed_signup_scroll">' +
        '<div class="mc-field-group">' +
        "<label for='mce-EMAIL' class='mc-field-group-label'>" +
        t("mailchimp-form-email-title") +
        "<span class='asterisk'>*</span>" +
        "</label>" +
        '<input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL" required>' +
        '<span id="mce-EMAIL-HELPERTEXT" class="helper_text"></span>' +
        '<div hidden=""><input type="hidden" name="tags" value="40197535"></div>' +
        "</div>" +
        '<div id="mergeRow-gdpr" class="mergeRow gdpr-mergeRow content__gdprBlock mc-field-group">' +
        '<div class="content__gdpr">' +
        "<h3>" +
        t("mailchimp-form-marketing-title") +
        "</h3>" +
        "<p>" +
        t("mailchimp-form-marketing-text") +
        "</p>" +
        '<fieldset class="mc_fieldset gdprRequired mc-field-group" name="interestgroup_field">' +
        "<label class='checkbox subfield' for='gdpr_136588'><input type='checkbox' id='gdpr_136588' name='gdpr[136588]' value='Y' class='av-checkbox gdpr'><span>" +
        t("mailchimp-form-email-label") +
        "</span> </label>" +
        "</fieldset>" +
        "<p>" +
        t("mailchimp-form-marketing-unsubscribe-text") +
        "</p>" +
        "</div>" +
        '<div class="content__gdprLegal">' +
        "<p>" +
        t("mailchimp-form-marketing-gdpr-agreement-text") +
        "</p>" +
        "</div>" +
        "</div>" +
        '<div id="mce-responses" class="clear">' +
        '<div class="response" id="mce-error-response" style="display:none"></div>' +
        '<div class="response" id="mce-success-response" style="display:none"></div>' +
        "</div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->" +
        '<div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_fd9e30f054d2eb89045417926_88d8999242" tabindex="-1" value=""></div>' +
        "<div class='clear'><input type='submit' value=" +
        t("mailchimp-form-subscribe-label") +
        " name='subscribe' id='mc-embedded-subscribe' class='button' style='width:100%;margin-top:2rem !important'></div>" +
        "</div>" +
        "</form>" +
        "</div>" +
        "<script type='text/javascript' src='//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js'></script><script type='text/javascript'>(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';}(jQuery));var $mcj = jQuery.noConflict(true);</script>" +
        "<!--End mc_embed_signup-->";

    return (
        <div
            className={`mailchimp-form ${
                props.className ? props.className : ""
            }`}
            dangerouslySetInnerHTML={{ __html: mailchimpNewsletterHTML }}
        ></div>
    );
}

{
    /*
<form action="https://2xper.us14.list-manage.com/subscribe/post?u=fd9e30f054d2eb89045417926&amp;id=88d8999242&amp;v_id=5050&amp;f_id=0087b6e5f0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank"></form>
 <div class="mc-field-group"><label for="mce-EMAIL">Email Address <span class="asterisk">*</span></label><input type="email" name="EMAIL" class="required email" id="mce-EMAIL" required="" value=""></div><div class="mc-field-group input-group"><strong>I Represent </strong><ul><li><input type="radio" name="MMERGE2" id="mce-MMERGE20" value="Private Person"><label for="mce-MMERGE20">Private Person</label></li><li><input type="radio" name="MMERGE2" id="mce-MMERGE21" value="Company"><label for="mce-MMERGE21">Company</label></li><li><input type="radio" name="MMERGE2" id="mce-MMERGE22" value="Association"><label for="mce-MMERGE22">Association</label></li></ul></div><div class="mc-field-group input-group"><strong>I Manage </strong><ul><li><input type="radio" name="MMERGE1" id="mce-MMERGE10" value="Under 100 hectares"><label for="mce-MMERGE10">Under 100 hectares</label></li><li><input type="radio" name="MMERGE1" id="mce-MMERGE11" value="100-1000 hectares"><label for="mce-MMERGE11">100-1000 hectares</label></li><li><input type="radio" name="MMERGE1" id="mce-MMERGE12" value="Over 1000 hectares"><label for="mce-MMERGE12">Over 1000 hectares</label></li></ul></div><div class="mc-field-group"><label for="mce-MMERGE3">What makes Global Forester interesting to you? </label><input type="text" name="MMERGE3" class=" text" id="mce-MMERGE3" value=""></div><div id="mergeRow-gdpr" class="mergeRow gdpr-mergeRow content__gdprBlock mc-field-group"><div class="content__gdpr"><label>Marketing Permissions</label><p>Please select all the ways you would like to hear from IT Bolaget Per &amp; Per AB:</p><fieldset class="mc_fieldset gdprRequired mc-field-group" name="interestgroup_field"><label class="checkbox subfield" for="gdpr136588"><input type="checkbox" id="gdpr_136588" name="gdpr[136588]" class="gdpr" value="Y"><span>Email</span></label></fieldset><p>You can unsubscribe at any time by clicking the link in the footer of our emails. For information about our privacy practices, please visit our website.</p></div><div class="content__gdprLegal"><p>We use Mailchimp as our marketing platform. By clicking below to subscribe, you acknowledge that your information will be transferred to Mailchimp for processing. <a href="https://mailchimp.com/legal/terms">Learn more</a> about Mailchimp's privacy practices.</p></div></div>
*/
}
